import React from 'react';
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {GamePlayMobileHeaderTopLeftContainerBox} from "../../boxes/top-section/game-play-mobile-header-top-left-container.box";
import {GamePlayMobileHeaderBarClockComponent} from "../../parts/clock/game-play-mobile-header-bar-clock.component";
import {GamePlayMobileHeaderBarComponent} from "../../game-play-mobile-header-bar.component";
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {
    InGameUserSessionTimerComponent,
    InGameUserSessionTimerPipeSeparatorRenderPosition
} from "../../../../../../clock-and-last-login-box/session-timer/in-game/in-game-user-session-timer.component";
import {
    NetherlandsResponsibleGamingButtonsComponent
} from "../../../../../../responsible-gambling/responsible-gaming-buttons/regulations/netherlands/netherlands.responsible-gaming-buttons.component";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {
    NetherlandsMinimumGamblingAgeComponent
} from "../../../../../../responsible-gambling/minimum-gambling-age/regulations/netherlands/netherlands.minimum-gambling-age.component";

export const NetherlandsGamePlayMobileHeaderBarComponent = observer(
    class NetherlandsGamePlayMobileHeaderBarComponent extends OrbitComponent<{gameContext: IGameContextViewModel}> {
        private _renderTopSection = () => {
            return (
                <GamePlayMobileHeaderTopLeftContainerBox>
                    <BlankHorizontalSeparatorBox/>
                    <GamePlayMobileHeaderBarClockComponent/>
                    <InGameUserSessionTimerComponent pipeSeparatorPosition={InGameUserSessionTimerPipeSeparatorRenderPosition.Before}/>
                    <BlankHorizontalSeparatorBox />
                    <NetherlandsMinimumGamblingAgeComponent/>
                    <BlankHorizontalSeparatorBox multiplier={2}/>
                    <NetherlandsResponsibleGamingButtonsComponent/>
                </GamePlayMobileHeaderTopLeftContainerBox>

            );
        }

        render() {
            return (
                <GamePlayMobileHeaderBarComponent gameContext={this.props.gameContext}
                                                  renderTopLeftSection={this._renderTopSection}/>

            )
        }
    }
);